export default __webpack_public_path__ + "img/return-log.bcd29e.svg";